<template>
  <v-row>
    <v-col>
      <general-error v-if="!!generalError && !dialogOpened" />
      <v-row v-if="isAdmin || isOrganizer">
        <v-col cols="12" class="text-right">
          <btn-icon-tip
              v-if="canCreateTemplate"
              icon="file_copy"
              icon-color="primary"
              :tip="$t('Сохранить как шаблон')"
              :disabled="loading"
              @click="saveAsTemplate" />
          <btn-icon-tip
              v-if="(isAdmin || isLotOwner(lot)) && lot.canEditLot"
              icon="edit"
              icon-color="primary"
              :disabled="loading"
              :tip="$t('Редактирование торговой процедуры')"
              @click="openEditLotDialog" />
        </v-col>
      </v-row>
      <v-progress-linear :active="loading" color="loader" indeterminate />
      <lot-info-view
          :lot="lot"
          positions
          sessions>
        <template v-slot:positions>
          <positions-list
              v-if="lot.lotId"
              :positions="positions"
              :can-edit="lot.canEditPosition"
              :can-add="lot.canCreatePosition"
              :lot="lot"
              :loading="loading"
              @change="change" />
        </template>
        <template v-slot:sessions>
          <sessions-list
              v-if="lot.lotId"
              :sessions="sessions"
              :positions-count="positionsCount"
              :lot="lot"
              :loading="loading"
              @change="change" />
        </template>
      </lot-info-view>
      <!-- <v-row class="text-left pt-2">
        <v-col>
          <v-btn
              v-if="canCreateTemplate"
              id="saveAsTemplate"
              v-test="{ btn: 'saveAsTemplate' }"
              color="primary"
              :disabled="loading"
              @click.stop="saveAsTemplate">
            {{ $t('Сохранить как шаблон') }}
          </v-btn>
        </v-col>
      </v-row> -->
      <edit-lot-dialog
          v-if="editLotDialog.show"
          :dialog-prop="editLotDialog"
          @close="closeDialog('editLotDialog')" />
    </v-col>
  </v-row>
</template>

<script>
  import LotInfoView from '@/components/reused/lot/LotInfoView.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import EditLotDialog from './EditLotDialog.vue'
  import PositionsList from '@/components/reused/positions/PositionsList.vue'
  import SessionsList from '@/components/reused/sessions/SessionsList.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { mapActions } from 'vuex'
  import { LOT_TEMPLATE_MANAGEMENT } from '@/constants/store.js'
  import { LOT_STATUSES } from '@/constants/business.js'

  export default {
    components: {
      LotInfoView,
      PositionsList,
      SessionsList,
      EditLotDialog,
      BtnIconTip,
      GeneralError
    },
    props: {
      lot: {
        type: Object,
        default: () => {
          return {}
        }
      },
      positions: {
        type: Array,
        default: () => {
          return []
        }
      },
      sessions: {
        type: Array,
        default: () => {
          return []
        }
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        editLotDialog: {
          show: false,
          lot: null,
          callback: null
        }
      }
    },
    computed: {
      dialogOpened () {
        return this.editLotDialog.show
      },
      positionsCount () {
        return this.positions.length
      },
      canCreateTemplate () {
        return (this.lot.lotStatus === LOT_STATUSES.REGISTERED ||
          this.lot.lotStatus === LOT_STATUSES.FINISHED) &&
          this.isOrganizer
        // this.isLotOwner(this.lot)
      }
    },
    methods: {
      ...mapActions(LOT_TEMPLATE_MANAGEMENT.NAMESPACE, {
        saveAsTemplateAction: LOT_TEMPLATE_MANAGEMENT.ACTIONS.SAVE_AS_TEMPLATE
      }),
      saveAsTemplate: async function () {
        try {
          await this.saveAsTemplateAction({
            lotId: this.lot.lotId,
            lotType: this.lot.lotType
          })
          this.goToRoute(`${this.urlRootPath}/templates`)
        } catch (error) {
          this.throwIfNotServerError(error)
        }
      },
      openEditLotDialog: function () {
        this.editLotDialog.lot = this.lot
        this.editLotDialog.callback = this.change
        this.editLotDialog.show = true
      },
      change: function () {
        this.$emit('change')
      }
    }
  }
</script>
